import {inject, Injectable} from '@angular/core';
import {ToastController, LoadingController} from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root'
})
export class UiService {

  private toaster = inject(ToastController);
  private loadingCtl = inject(LoadingController);

  async mostrarToast(msg?: string, error: boolean = false, position: 'bottom' | 'top' | 'middle' = 'bottom') {
    const toast = await this.toaster.create({
      message: msg || (error ? 'Error en la aplicación' : 'Operación completada'),
      duration: error ? 4000 : 3000,
      position,
      color: error ? 'danger' : 'dark',
      buttons: [{text: 'OK', role: 'cancel'}]
    })
    await toast.present()
  }

  async load(text?: string) {
    return this.loadingCtl.create({
      message: text || '',
      animated: !text,
      spinner: text ? 'bubbles' : 'dots'
    })
  }

}